module.exports = __webpack_public_path__ + "media/evolve/assets/icons/fontawesome/solid/bold-a936ac9bec344b5aba64ce18a765e113.svg";